"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetProbeService = void 0;
const Leaf = __importStar(require("leaf-ts"));
const interlock_McpConsent_1 = require("@branch-ts/biome-ai-web/src/interlock.McpConsent");
const app_consensus_1 = require("@branch-ts/app-consensus");
const cas_1 = require("@branch-ts/cas");
const cps_consensus_1 = require("@branch-ts/cps-consensus");
const debug_consensus_1 = require("@branch-ts/debug-consensus");
const fsExhibitionMechanism_1 = require("@branch-ts/biome-media-web/src/file/fsExhibitionMechanism");
const idps_consensus_1 = require("@branch-ts/idps-consensus");
const practice_probe_client_1 = require("@branch-ts/practice-probe-client");
const src_1 = require("@branch-ts/probe-consensus/src");
const puri_1 = require("@branch-ts/puri");
const web_consensus_1 = require("@branch-ts/web-consensus");
const term_consensus_1 = require("@branch-ts/term-consensus");
const puri_2 = require("@branch-ts/puri");
const with_caution_1 = require("with-caution");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
let VersetProbeService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetProbeService = class {
        static { _classThis = this; }
        constructor() {
            this.debug = debug_consensus_1.Debug.instance(this).tag("VersetProbeService");
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
            });
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetProbeService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        get terminalDomains() {
            return this.probeSessionManager.terminalDomains;
        }
        refreshRecordedProbeInventory() {
            this.recordedProbeInventoryRequest ??= this.loadRecordedProbeInventory().finally(() => {
                this.recordedProbeInventoryRequest = undefined;
            });
            return this.recordedProbeInventoryRequest;
        }
        async loadRecordedProbeInventory() {
            let probes;
            let inventoryError;
            try {
                const [records, reason, ...errors] = await this.listMyProbes({ count: -1 });
                if (!reason && records) {
                    probes = records.items.map(record => ({ uri: record.uri, name: record.displayName, probeType: record.probeType }));
                }
                else
                    inventoryError = with_caution_1.CautionUtil.error(reason || "Unknown", ...errors);
            }
            catch (error) {
                inventoryError = error instanceof Error ? error : new Error(String(error));
            }
            const changed = JSON.stringify(this.recordedProbes) !== JSON.stringify(probes);
            this.recordedProbes = probes;
            this.recordedProbeInventoryError = inventoryError;
            if (changed)
                this.probeSessionManager?.events.emit("change");
            return this.getRecordedProbeInventory();
        }
        getRecordedProbeInventory() {
            if (!this.recordedProbes) {
                return [, "ProbeNotReady", this.recordedProbeInventoryError || new Error("Recorded Probe inventory is still loading")];
            }
            return [{ probeURIs: this.recordedProbes.map(probe => probe.uri) }];
        }
        /** Account identities are authoritative; do not turn saved offline records into connection candidates. */
        getProbeInventory() {
            if (this.recordedProbeInventoryRequest)
                return [, "ProbeNotReady", new Error("Recorded Probe inventory is refreshing")];
            const [, reason, ...errors] = this.getRecordedProbeInventory();
            if (reason)
                return [, reason, ...errors];
            return (0, practice_probe_client_1.getProbeInventory)(this.probeSessionManager, this.recordedProbes);
        }
        async requestProbe(option) {
            if (!src_1.ProbeProtocol.ProbeURI.parse(option.uri)?.probeId)
                return [, "InvalidParameters", new Error("Expected an exact Probe URI")];
            const [, inventoryReason, ...inventoryErrors] = await this.refreshRecordedProbeInventory();
            if (inventoryReason)
                return [, inventoryReason, ...inventoryErrors];
            const result = await (0, practice_probe_client_1.requestProbe)(this.probeSessionManager, option, this.recordedProbes);
            // A refresh may have removed this identity while connection discovery was in flight.
            if (this.recordedProbeInventoryRequest)
                return [, "ProbeNotReady", new Error("Recorded Probe inventory is refreshing")];
            const [, finalReason, ...finalErrors] = this.getRecordedProbeInventory();
            if (finalReason)
                return [, finalReason, ...finalErrors];
            if (!this.recordedProbes?.some(probe => probe.uri === option.uri))
                return [, "NotFound", new Error("Probe is no longer registered for this account")];
            return result;
        }
        resolveProbeHost(option) {
            return (0, practice_probe_client_1.resolveProbeHostTarget)(this.probeSessionManager, option);
        }
        resolveProbeTerminal(option) {
            return (0, practice_probe_client_1.resolveProbeTerminalTarget)(this.probeSessionManager, option);
        }
        getMissingProbeReason() {
            const [inventory, reason, ...errors] = this.getRecordedProbeInventory();
            if (reason)
                return [, "ProbeNotReady", ...errors];
            return inventory.probeURIs.length === 0
                ? [, "NoProbeSetup", new Error("No Probe is registered for this account")]
                : [, "ProbeNotReachable", new Error("Recorded Probes are not reachable")];
        }
        get server() {
            return this.deps.VersetRequireLoginService.server;
        }
        get rpc() {
            return this.server.rpcs.VersetUserProbeService;
        }
        addAccessPoint(accessPointEntry) {
            const uri = accessPointEntry.info.uri;
            this.debug.log("Adding access point", uri);
            if (accessPointEntry.info.type === "util" || accessPointEntry.info.type === "hostExec" || accessPointEntry.info.type === "mcp")
                return;
            // Terminal projection factories follow TerminalDomainManager, including offline entries.
            if (accessPointEntry.info.type === "term")
                return;
            addFileSystem: {
                const fileSystemInfo = cps_consensus_1.CPSProtocol.FileSystemURI.parse(uri);
                if (!fileSystemInfo) {
                    break addFileSystem;
                }
                const probeInfo = puri_2.PURI.decomposeVendor(fileSystemInfo.vendor);
                if (!probeInfo) {
                    break addFileSystem;
                }
                if (probeInfo.protocol !== "probe" || probeInfo.kind !== "probe") {
                    break addFileSystem;
                }
                if (!accessPointEntry.situations.get("online")) {
                    throw new Error("Access point is not available: " + uri);
                }
                const layeredFileSystemInteraction = new cps_consensus_1.LayeredFileSystemInteraction({
                    fileSystemsFromBottomToTop: [(0, practice_probe_client_1.probeFileSystemAccess)(this.probeSessionManager, accessPointEntry.entry.uri, uri)],
                });
                this.debug.log("Adding file system to registry", uri);
                cps_consensus_1.FileSystemProviderRegistryMechanism.single({
                    uri,
                    single: layeredFileSystemInteraction,
                });
                fsExhibitionMechanism_1.FSExhibitionRegistryMechanism.add({
                    uri,
                    name: accessPointEntry.info.name || `${accessPointEntry.entry.displayName} Files`,
                    sourceLabel: accessPointEntry.entry.displayName || accessPointEntry.info.name,
                    isSearchAvailable: () => accessPointEntry.situations.get("online"),
                    watchSearchAvailability: notify => {
                        const owner = {};
                        accessPointEntry.situations.syncBy(owner, "online", notify);
                        return { cancel: () => accessPointEntry.situations.stopSyncBy(owner) };
                    },
                });
                return;
            }
            throw new Error("Invalid access point URI: " + uri);
        }
        async setupProbe(input) {
            const probeSessionManager = new practice_probe_client_1.UserProbeSessionManager({
                clientDistributerAccess: {
                    getDistributerPublicInfo: async () => {
                        return await this.getProbeDistributerPublicInfo();
                    },
                    getProbeCandidates: async () => {
                        const [, candidates] = await Promise.all([
                            this.refreshRecordedProbeInventory(),
                            this.listMyOnlineProbeCandidates(),
                        ]);
                        return candidates;
                    },
                    createProbeCandidateStream: async () => {
                        const [result, reason, ...errors] = await this.server.rpcs.VersetUserProbeService.createMyProbeCandidateStream({});
                        if (reason)
                            return [, "Unknown", ...errors];
                        return [result];
                    },
                    initExchangeRequest: async (option) => {
                        return await this.rpc.initMyProbeExchangeRequest(option);
                    },
                    feedClientIceCandidate: async (option) => {
                        return await this.rpc.feedMyProbeClientIceCandidate(option);
                    },
                },
            });
            const registeredEndpointSet = new Set();
            const wiredAccessPointEntries = new Set();
            const wireAccessPoint = (accessPointEntry) => {
                if (wiredAccessPointEntries.has(accessPointEntry)) {
                    return;
                }
                wiredAccessPointEntries.add(accessPointEntry);
                accessPointEntry.situations.syncBy(this, "online", (online) => {
                    if (!online) {
                        return;
                    }
                    const accessPointURI = accessPointEntry.info.uri;
                    if (registeredEndpointSet.has(accessPointURI)) {
                        return;
                    }
                    this.debug.log("Access point online", accessPointURI);
                    this.addAccessPoint(accessPointEntry);
                    registeredEndpointSet.add(accessPointURI);
                });
            };
            this.probeSessionManager = probeSessionManager;
            this.terminalProjections = new term_consensus_1.TerminalDomainProjections(this.terminalDomains);
            (0, interlock_McpConsent_1.registerMcpConsentResolution)(probeSessionManager);
            this.bindExecutionReadyFeedback();
            probeSessionManager.events.of.accessPointEntryAdded.listenBy(this, (event) => {
                this.debug.log("Access point detected", { event });
                wireAccessPoint(event.accessPointEntry);
            });
            // Local devices are optional. Discovery owns its loading/failure state;
            // a pending API request must not prevent the workspace from opening.
            // accessPointEntryAdded already wires entries when discovery completes.
            void Promise.all([this.refreshRecordedProbeInventory(), probeSessionManager.sync()]).catch(error => {
                this.debug.error("Initial Probe discovery failed", { error });
            });
            web_consensus_1.PuriAppMechanism.register({
                name: "ProbeURI Should open probe explorer",
                cache: true,
                registry: (option) => {
                    const probeURIInfo = src_1.ProbeProtocol.ProbeURI.parse(option.uri);
                    if (!probeURIInfo) {
                        return null;
                    }
                    throw new Error("Not implemented");
                },
            });
            cas_1.PuriRuneConceptMechanism.packageOf(input.editorKind).register({
                kind: "probe+probe",
                trigger: (option) => {
                    const probeURI = src_1.ProbeProtocol.ProbeURI.parse(option.uri);
                    if (!probeURI) {
                        return;
                    }
                    return true;
                },
            });
            puri_1.PURIDigestMechanism.register({
                name: "probe+probe",
                digest: async (option) => {
                    const probeURIInfo = src_1.ProbeProtocol.ProbeURI.parse(option.uri);
                    if (!probeURIInfo) {
                        return null;
                    }
                    await probeSessionManager.sync();
                    const probeEntry = probeSessionManager.probeEntryRegistry.get(option.uri);
                    if (!probeEntry) {
                        return [, "NotFound", new Error(`Probe not found in current probe session: ${option.uri}`)];
                    }
                    const createBrief = () => {
                        const displayName = probeEntry.displayName || probeURIInfo.probeId;
                        return displayName;
                    };
                    const createDigestStyle = () => {
                        const isOnline = probeEntry.situations.get("online");
                        const isAvailable = probeEntry.situations.get("available");
                        const color = isOnline
                            ? "#4caf50"
                            : isAvailable
                                ? "#ff9800"
                                : "#777";
                        return {
                            color,
                        };
                    };
                    if (!option.stream) {
                        return [{ brief: createBrief(), style: createDigestStyle() }];
                    }
                    const digestStream = new Leaf.Stream();
                    const digestListener = {};
                    const emitDigest = () => {
                        if (!digestStream.isFeedable) {
                            return;
                        }
                        digestStream.feed({
                            type: "brief",
                            brief: createBrief(),
                            style: createDigestStyle(),
                            length: 1,
                        });
                    };
                    probeEntry.situations.events.listenBy(digestListener, "online", () => {
                        emitDigest();
                    });
                    probeEntry.situations.events.listenBy(digestListener, "available", () => {
                        emitDigest();
                    });
                    probeSessionManager.events.listenBy(digestListener, "change", () => {
                        emitDigest();
                    });
                    digestStream.onCleanUp = () => {
                        probeEntry.situations.events.stopListenBy(digestListener);
                        probeSessionManager.events.stopListenBy(digestListener);
                    };
                    return [{
                            brief: createBrief(),
                            style: createDigestStyle(),
                            stream: digestStream,
                        }];
                },
            });
        }
        async initialize() {
            const agreement = this.deps.VersetRequireLoginService.agreement;
            await this.setupProbe({
                editorKind: agreement.particulars.versetWebapp.verse.editorKind,
            });
            this.bindSessionLifetime();
        }
        bindSessionLifetime() {
            // Match Era's manager lifetime: a network/auth handshake failure is not
            // logout. Disposing here closes otherwise healthy direct Probe sessions
            // and permanently stops discovery, even after the socket recovers.
            this.deps.VersetRequireLoginService.deps.SessionService.situations.syncBy(this, "auth", auth => {
                if (!auth)
                    this.probeSessionManager.dispose();
            });
            this.server.events.listenBy(this, "autoReAuthFailed", () => this.probeSessionManager.dispose());
            this.server.events.listenBy(this, "authorized", () => { void this.probeSessionManager.sync(); });
        }
        async destroy() {
            this.deps.VersetRequireLoginService.deps.SessionService.situations.stopSyncBy(this);
            this.server.events.stopListenBy(this);
            this.probeSessionManager?.dispose();
            this.terminalProjections?.destroy();
        }
        resolveUtilAccess(to) {
            return (0, practice_probe_client_1.resolveUtilAccess)(this.probeSessionManager, to);
        }
        hasReadyHostExecution(probeURI, cwd) {
            const [bindings, reason] = this.getHostExecFileSystemBindings();
            const cwdInfo = cwd ? cps_consensus_1.CPSProtocol.FilePathFamilyURI.parse(cwd) : undefined;
            if (cwd && !cwdInfo)
                return false;
            return !reason && !!bindings?.endpoints.some(endpoint => endpoint.online
                && (!probeURI || endpoint.probeURI === probeURI)
                && endpoint.fsAliases.some(alias => {
                    if (!cwdInfo)
                        return true;
                    const info = cps_consensus_1.CPSProtocol.FilePathFamilyURI.parse(alias.uri);
                    return info && info.vendor === cwdInfo.vendor && info.fsId === cwdInfo.fsId
                        && (!info.path || info.path === cwdInfo.path || cwdInfo.path.startsWith(`${info.path}/`));
                }));
        }
        bindExecutionReadyFeedback() {
            this.probeSessionManager.events.listenBy(this, "change", () => {
                if (!this.hasReadyHostExecution())
                    return;
                void idps_consensus_1.InterlockResolveFeedbackMechanism.feedback({ cause: "NoProbeSetup" });
            });
        }
        getTerminalFileSystemBindings() {
            if (this.probeSessionManager.situations.get("initialization") !== "ready") {
                return [, "ProbeNotReady", new Error("Probe setup is still loading")];
            }
            const bindings = [];
            const probeEntries = Array.from(this.probeSessionManager.probeEntryRegistry.values());
            for (const probeEntry of probeEntries) {
                if (probeEntry.probe && !probeEntry.situations.get("online"))
                    continue;
                const terminals = probeEntry.accessPointEntries.filter((entry) => {
                    return !!term_consensus_1.TermProtocol.TerminalDomainURI.parse(entry.info.uri);
                });
                const fileSystems = probeEntry.accessPointEntries.flatMap((entry) => {
                    const info = cps_consensus_1.CPSProtocol.FileSystemURI.parse(entry.info.uri);
                    const accessInfo = entry.info;
                    if (!info || accessInfo.type !== "fs") {
                        return [];
                    }
                    return [{
                            entry,
                            path: accessInfo.hostPath,
                            uri: accessInfo.uri,
                        }];
                });
                for (const terminal of terminals) {
                    const terminalInfo = term_consensus_1.TermProtocol.TerminalDomainURI.parse(terminal.info.uri);
                    for (const fileSystem of fileSystems) {
                        bindings.push({
                            vendor: terminalInfo.vendor,
                            interlockDetail: {
                                probeURI: probeEntry.uri,
                                terminalAccessPointURI: terminal.uri,
                            },
                            terminalDomain: this.getTerminalDomain(terminal),
                            fsAliases: [{
                                    uri: fileSystem.uri,
                                    path: fileSystem.path,
                                }],
                        });
                    }
                }
            }
            if (bindings.length > 0) {
                return [bindings];
            }
            if (probeEntries.length === 0) {
                return this.getMissingProbeReason();
            }
            if (probeEntries.some(entry => entry.probe && !entry.ready)) {
                return [, "ProbeNotReady", new Error("Probe access negotiation is still loading")];
            }
            if (probeEntries.every((entry) => !entry.probe && !entry.situations.get("online"))) {
                return [, "ProbeNotReachable", new Error("Known Probes are not reachable")];
            }
            return [bindings];
        }
        getHostExecFileSystemBindings() {
            if (this.probeSessionManager.situations.get("initialization") !== "ready") {
                return [, "ProbeNotReady", new Error("Probe setup is still loading")];
            }
            const bindings = [];
            const probeEntries = Array.from(this.probeSessionManager.probeEntryRegistry.values());
            for (const probeEntry of probeEntries) {
                if (probeEntry.probe && !probeEntry.situations.get("online"))
                    continue;
                const hostExecs = probeEntry.accessPointEntries.filter((entry) => term_consensus_1.TermProtocol.HostURI.parse(entry.info.uri));
                const fsAliases = probeEntry.accessPointEntries.flatMap((entry) => {
                    const fsInfo = cps_consensus_1.CPSProtocol.FileSystemURI.parse(entry.info.uri);
                    const accessInfo = entry.info;
                    return fsInfo && accessInfo.type === "fs" ? [{
                            uri: accessInfo.uri,
                            path: accessInfo.hostPath,
                        }] : [];
                });
                for (const hostExec of hostExecs) {
                    const hostInfo = term_consensus_1.TermProtocol.HostURI.parse(hostExec.info.uri);
                    bindings.push({
                        vendor: hostInfo.vendor,
                        online: probeEntry.situations.get("online"),
                        probeURI: probeEntry.uri,
                        interlockDetail: {
                            probeURI: probeEntry.uri,
                            hostExecAccessPointURI: hostExec.uri,
                        },
                        hostExec: this.getHostExec(hostExec),
                        fsAliases,
                    });
                }
            }
            const [inventory, inventoryReason] = this.getRecordedProbeInventory();
            // A live/session list cannot establish that this is a single-device account.
            // Unknown or refreshing account truth disables only automatic cwd selection.
            const knownProbeURIs = !inventoryReason && !this.recordedProbeInventoryRequest
                ? [...new Set([...inventory.probeURIs, ...probeEntries.map(entry => entry.uri)])]
                : undefined;
            if (bindings.length > 0)
                return [{
                        endpoints: bindings,
                        knownProbeURIs,
                    }];
            if (probeEntries.length === 0) {
                return this.getMissingProbeReason();
            }
            if (probeEntries.some(entry => entry.probe && !entry.ready)) {
                return [, "ProbeNotReady", new Error("Probe access negotiation is still loading")];
            }
            if (probeEntries.every((entry) => !entry.probe && !entry.situations.get("online"))) {
                return [, "ProbeNotReachable", new Error("Known Probes are not reachable")];
            }
            return [{
                    endpoints: bindings,
                    knownProbeURIs,
                }];
        }
        getHostExec(accessPoint) {
            return (0, practice_probe_client_1.probeHostExecAccess)(this.probeSessionManager, accessPoint.entry.uri, accessPoint.uri);
        }
        getTerminalDomain(accessPoint) {
            return (0, practice_probe_client_1.probeTerminalAccess)(this.probeSessionManager, accessPoint.entry.uri, accessPoint.uri);
        }
        async listMyProbes(option = {}) {
            return await this.server.rpcs.VersetUserProbeService.listMyProbes(option);
        }
        async getMyProbe(option) {
            return await this.rpc.getMyProbe(option);
        }
        async listMyOnlineProbeCandidates() {
            return await this.rpc.listMyOnlineProbeCandidates({});
        }
        async getProbeDistributerPublicInfo() {
            return await this.rpc.getProbeDistributerPublicInfo({});
        }
    };
    return VersetProbeService = _classThis;
})();
exports.VersetProbeService = VersetProbeService;
